/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EffectiveLaborCostDtoPage } from '../../models/effective-labor-cost-dto-page';

export interface ListEffectiveLaborCosts$Params {
  projectIds?: Array<string>;
  costTypeIds?: Array<string>;
  budgetIds?: Array<string>;
  wpIds?: Array<string>;
  userIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'from' | '-from' | 'to' | '-to' | 'projectName' | '-projectName' | 'budgetName' | '-budgetName' | 'total' | '-total' | 'totalSeconds' | '-totalSeconds' | 'workPackageName' | '-workPackageName' | 'laborActivityName' | '-laborActivityName' | 'laborName' | '-laborName' | 'username' | '-username'>;
}

export function listEffectiveLaborCosts(http: HttpClient, rootUrl: string, params?: ListEffectiveLaborCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveLaborCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEffectiveLaborCosts.PATH, 'get');
  if (params) {
    rb.query('projectIds', params.projectIds, {});
    rb.query('costTypeIds', params.costTypeIds, {});
    rb.query('budgetIds', params.budgetIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('userIds', params.userIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EffectiveLaborCostDtoPage>;
    })
  );
}

listEffectiveLaborCosts.PATH = '/v0/effectiveLaborCost';
